import { render, staticRenderFns } from "./QuestionCounter.vue?vue&type=template&id=70983718&scoped=true&"
import script from "./QuestionCounter.vue?vue&type=script&lang=ts&"
export * from "./QuestionCounter.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionCounter.vue?vue&type=style&index=0&id=70983718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70983718",
  null
  
)

export default component.exports